import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { isEmpty, isFunction, isEqual } from "lodash";
import { useEffect, useRef, useState } from "react";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

function SelectMenu({ options, selectedId, onSelect, labelText, required }) {
    const [selectedValue, setValue] = useState(
        (selectedId && isEmpty(selectedId) && options.find((item) => item.id === selectedId)) || options[0]
    );

    const buttonRef = useRef(null);
    const [openUpward, setOpenUpward] = useState(false);

    const checkDirection = () => {
        if (!buttonRef.current) return;
        
        const rect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const dropdownHeight = 240; // 예상 옵션 높이 (max-h-60 = 15rem = 240px)

        setOpenUpward(spaceBelow < dropdownHeight);
    };

    useEffect(() => {
        checkDirection();
        window.addEventListener("resize", checkDirection);
        return () => window.removeEventListener("resize", checkDirection);
    }, []);

    const handleSelectValue = (val) => {
        console.log("🚀 ~ handleSelectValue ~ val:", val);
        if (onSelect && isFunction(onSelect)) {
            setValue(val);
            onSelect(val);
        }
    };

    useEffect(() => {
        if (options && !isEmpty(options)) {
            // console.log("🚀 ~ useEffect ~ options:", options);
            // console.log("🚀 ~ useEffect ~ selectedId:", selectedId);
            if (isEmpty(selectedId)) {
                setValue(options[0]);
            }
        }
    }, [options]);

    useEffect(() => {
        // console.log("🚀 ~ SelectMenu ~ selectedId:", selectedId);
        if (!isEmpty(selectedId)) {
            const foundObj = options.find((item) => item.id === selectedId);
            if (foundObj && !isEmpty(foundObj)) {
                setValue(foundObj);
            }
        }
    }, [selectedId]);

    if (!selectedValue) return <div />;

    return (
        <Listbox value={selectedValue} onChange={handleSelectValue}>
            {labelText && !isEmpty(labelText) && (
                <div className="inline-flex">
                    <Label className="block text-sm font-semibold leading-6 text-gray-900">{labelText}</Label>
                    {required && <label className="ml-1 text-red-700 font-bold">*</label>}
                </div>
            )}
            <div className={classNames(labelText && !isEmpty(labelText) ? "mt-2" : "", "relative")} ref={buttonRef}>
                <ListboxButton className="relative w-full cursor-default rounded bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
                    <span className="block truncate">{selectedValue.name}</span>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <ChevronUpDownIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                    </span>
                </ListboxButton>

                <ListboxOptions
                    transition
                    className={`absolute z-50 w-full max-h-60 w-full overflow-auto rounded bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm ${openUpward ? "bottom-full mb-1" : "mt-1 top-full"}`}
                >
                    {options.map((option) => (
                        <ListboxOption
                            key={option.id}
                            value={option}
                            className="group relative cursor-default select-none py-2 px-3 text-gray-900 data-[focus]:bg-blue-600 data-[focus]:text-white"
                        >
                            <span
                                className={classNames(
                                    isEqual(selectedValue, option) ? "font-semibold" : "",
                                    "block truncate font-normal group-data-[focus]:font-semibold"
                                )}
                            >
                                {option.name}
                            </span>
                            {isEqual(selectedValue, option) && (
                                <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-blue-600  group-data-[focus]:text-white ">
                                    <CheckIcon aria-hidden="true" className="h-5 w-5" />
                                </span>
                            )}
                        </ListboxOption>
                    ))}
                </ListboxOptions>
            </div>
        </Listbox>
    );
}

export default SelectMenu;
